import React from 'react'
import { Link, useForm, usePage } from '@inertiajs/inertia-react'
import Layout from '../../../Shared/Layout/LayoutAdmin'
import Breadcrumbs from '../../../Shared/Components/Breadcrumbs'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

const LAYOUT_OPTIONS = [
    { value: 'product_tabs', label: 'Pestañas (producto / llenado / …)' },
    { value: 'sidebar_videos', label: 'Lista lateral + video o PDF' },
    { value: 'media_catalog', label: 'Lista lateral (mismo formato)' },
    { value: 'video_grid', label: 'Rejilla de videos' },
    { value: 'section_hub', label: 'Tarjetas de subcategorías' },
    { value: 'lesson_list', label: 'Lista lateral con datos del documento' },
]

const SectionEdit = ({ section, parentOptions = [] }) => {
    const { flash } = usePage().props
    const path = `/admin/sia/manage/sections/${section.slug}/edit`

    const sectionForm = useForm({
        title: section.title,
        slug: section.slug,
        description: section.description || '',
        layout_type: section.layout_type,
        banner_title: section.banner_title || '',
        cover_video_url: section.cover_video_url || '',
        order: section.order,
        parent_id: section.parent_id ?? '',
    })

    const submitSection = (e) => {
        e.preventDefault()
        sectionForm.transform((data) => ({
            ...data,
            parent_id: data.parent_id === '' || data.parent_id === null ? null : Number(data.parent_id),
        }))
        sectionForm.put(route('sia.manage.sections.update', section.slug))
    }

    const listUrl = route('sia.manage.section.items', section.slug)

    return (
        <>
            <div className="mb-5 mt-5">
                <Breadcrumbs currentPath={path} />
            </div>

            <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-6">
                <h1 className="fs-2 fw-bold text-gray-900 mb-0">Sección: {section.title}</h1>
                <div className="d-flex flex-wrap gap-2">
                    <Link href={listUrl} className="btn btn-sm btn-light-primary">
                        ← Listado de contenido (esta sección)
                    </Link>
                    <Link href={route('sia.section.show', section.slug)} className="btn btn-sm btn-light">
                        Vista previa publicada
                    </Link>
                </div>
            </div>

            {flash.success && <div className="alert alert-success mb-5">{flash.success}</div>}

            <Card className="mb-8">
                <Card.Header className="fw-semibold">Banner, maquetación y datos generales</Card.Header>
                <Card.Body>
                    <Form onSubmit={submitSection}>
                        <Row className="g-3 mb-3">
                            <Col md={6}>
                                <Form.Label>Título</Form.Label>
                                <Form.Control
                                    value={sectionForm.data.title}
                                    onChange={(e) => sectionForm.setData('title', e.target.value)}
                                />
                                {sectionForm.errors.title && <div className="text-danger small">{sectionForm.errors.title}</div>}
                            </Col>
                            <Col md={6}>
                                <Form.Label>Slug (URL)</Form.Label>
                                <Form.Control
                                    value={sectionForm.data.slug}
                                    onChange={(e) => sectionForm.setData('slug', e.target.value)}
                                />
                                {sectionForm.errors.slug && <div className="text-danger small">{sectionForm.errors.slug}</div>}
                            </Col>
                        </Row>
                        <Row className="g-3 mb-3">
                            <Col md={12}>
                                <Form.Label>Descripción</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={5}
                                    style={{ minHeight: 120 }}
                                    value={sectionForm.data.description}
                                    onChange={(e) => sectionForm.setData('description', e.target.value)}
                                />
                            </Col>
                        </Row>
                        <Row className="g-3 mb-3">
                            <Col md={4}>
                                <Form.Label>Tipo de maquetación</Form.Label>
                                <Form.Select
                                    value={sectionForm.data.layout_type}
                                    onChange={(e) => sectionForm.setData('layout_type', e.target.value)}
                                >
                                    {LAYOUT_OPTIONS.map((o) => (
                                        <option key={o.value} value={o.value}>
                                            {o.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Col>
                            <Col md={4}>
                                <Form.Label>Sección padre</Form.Label>
                                <Form.Select
                                    value={sectionForm.data.parent_id ?? ''}
                                    onChange={(e) => sectionForm.setData('parent_id', e.target.value)}
                                >
                                    <option value="">— Ninguna (menú raíz) —</option>
                                    {parentOptions.map((p) => (
                                        <option key={p.id} value={p.id}>
                                            {p.title} ({p.slug})
                                        </option>
                                    ))}
                                </Form.Select>
                            </Col>
                            <Col md={4}>
                                <Form.Label>Título del banner</Form.Label>
                                <Form.Control
                                    value={sectionForm.data.banner_title}
                                    onChange={(e) => sectionForm.setData('banner_title', e.target.value)}
                                />
                            </Col>
                            <Col md={2}>
                                <Form.Label>Orden</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={sectionForm.data.order}
                                    onChange={(e) => sectionForm.setData('order', parseInt(e.target.value, 10) || 0)}
                                />
                            </Col>
                            <Col md={12}>
                                <Form.Label>URL de video de portada (opcional)</Form.Label>
                                <Form.Control
                                    value={sectionForm.data.cover_video_url}
                                    onChange={(e) => sectionForm.setData('cover_video_url', e.target.value)}
                                />
                            </Col>
                        </Row>
                        <Button type="submit" variant="primary" disabled={sectionForm.processing}>
                            Guardar sección
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </>
    )
}

SectionEdit.layout = (page) => <Layout title={page.props.section?.title ? `SIA · ${page.props.section.title}` : 'SIA'}>{page}</Layout>

export default SectionEdit
